import React, { useState, useRef, useEffect } from 'react';
import styled from "styled-components";
import { connect } from "react-redux";
import { setSelectedParts } from "../actions/detailsPageActions";

const MultiSelectContainer = styled.div`
    position: relative;
    display: inline-block;
    width: 100%;
`;

const SelectBox = styled.div`
    border: 1px solid #d0d0d0;
    border-radius: 4px;
    background: white;
    cursor: pointer;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: rgb(233, 233, 233);

    &:hover {
        border-color: #999;
    }
`;

const DropdownList = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #d0d0d0;
    border-top: none;
    border-radius: 0 0 4px 4px;
    max-height: 300px;
    overflow-y: auto;
    z-index: 9999;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
`;

const OptionItem = styled.div`
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #f0f0f0;

    &:hover {
        background: #f8f9fa;
    }

    &:last-child {
        border-bottom: none;
    }

    input[type="checkbox"] {
        margin: 0;
        width: 16px;
        height: 16px;
        accent-color: #007bff;
    }

    span {
        flex: 1;
        text-align: left;
    }
`;

const SelectedOptionsContainer = styled.div`
    margin-top: 8px;
    padding: 8px 12px;
    background: #f8f9fa;
    border-radius: 4px;
    min-height: 30px;
    max-height: 100px;
    overflow-y: auto;
    border: 1px solid #e9ecef;
`;

const SelectedTag = styled.span`
    display: inline-block;
    background: #e3f2fd;
    color: #1976d2;
    padding: 4px 8px;
    margin: 2px 4px 2px 0;
    border-radius: 12px;
    font-size: 12px;
    position: relative;
`;

const RemoveButton = styled.button`
    background: none;
    border: none;
    color: #1976d2;
    cursor: pointer;
    font-size: 14px;
    margin-left: 4px;
    padding: 0;

    &:hover {
        color: #d32f2f;
    }
`;

const ChevronIcon = styled.span`
    transition: transform 0.2s;
    transform: ${props => props.isOpen ? 'rotate(90deg)' : 'rotate(270deg)'};
    margin-right: 12px;
    color: rgb(233, 233, 233);
    font-size: 25px;

    &::after {
        content: '<';
    }
`;

// Nowy styled component dla przycisku Clear
const ClearButton = styled.button`
    background: none;
    border: none;
    color: rgb(233, 233, 233);
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    margin-right: 8px;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 3px;
    transition: all 0.2s ease;

    &:hover {
        color: #999;
        background-color: #f5f5f5;
    }

    &:active {
        transform: scale(0.95);
    }
`;

// Container dla przycisków po prawej stronie
const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
`;

function Details({ selectedParts = [], setSelectedPartsChanged, orderParts, partNumberNameArray}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleOption = (option) => {
        const newSelectedParts = selectedParts.includes(option)
            ? selectedParts.filter(item => item !== option)
            : [...selectedParts, option];

        setSelectedPartsChanged(newSelectedParts);
    };

    const removeOption = (optionToRemove) => {
        const newSelectedParts = selectedParts.filter(item => item !== optionToRemove);
        setSelectedPartsChanged(newSelectedParts);
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };


    const clearAllOptions = (e) => {
        e.stopPropagation();
        setSelectedPartsChanged([]);
    };

    return (
        <div style={{fontFamily: "Roboto, Helvetica, Arial Rounded MT Bold, Arial, sans-serif !important", fontSize: 14, fontWeight: 400}}>
            Select parts names/numbers:
            <div style={{ textAlign: "center" }}>
                <MultiSelectContainer ref={dropdownRef} style={{paddingTop: 23}}>
                    <SelectBox onClick={toggleDropdown}>
                        <span style={{lineHeight: "33px", paddingLeft: "12px", paddingRight: "12px", color: "slategrey", fontFamily: "Roboto, Helvetica, Arial Rounded MT Bold, Arial, sans-serif !important", fontSize: 14, fontWeight: 400}}>
                            {selectedParts.length === 0
                                ? 'All'
                                : `Selected parts: (${selectedParts.length})`
                            }
                        </span>

                        <ButtonsContainer>
                            {selectedParts.length > 0 && (
                                <ClearButton
                                    onClick={clearAllOptions}
                                    title="Clear all selections"
                                >
                                    ×
                                </ClearButton>
                            )}
                            <ChevronIcon isOpen={isOpen} />
                        </ButtonsContainer>
                    </SelectBox>

                    {isOpen && (
                        <DropdownList>
                            {partNumberNameArray && partNumberNameArray.map((option) => (
                                <OptionItem key={option} onClick={() => toggleOption(option)}>
                                    <input
                                        type="checkbox"
                                        checked={selectedParts.includes(option)}
                                        onChange={() => {}} // Obsługiwane przez onClick na rodzicu
                                    />
                                    <span>{option}</span>
                                </OptionItem>
                            ))}
                        </DropdownList>
                    )}
                </MultiSelectContainer>
            </div>
        </div>
    );
}

const mapStateToProps = ({ clientPanel }) => {
    return {
        selectedParts: clientPanel.detailsPageReducer.selectedParts || [],
        ...clientPanel.detailsPageReducer.data,
        partNumberNameArray: clientPanel.detailsPageReducer.tableData.generalSummaryPerPart.partNumberNameArray
    };
};

function mapDispatchToProps() {
    return dispatch => ({
        setSelectedPartsChanged: val => dispatch(setSelectedParts(val))
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(Details);